import Box from '@mui/material/Box'

const barStyle = {
  position: 'absolute',
  zIndex: 0,
  height: 17,
  top: '50%',
  transform: 'translate(0, -50%)',
  borderRadius: 10,
}

const COLOR = {
  INPROGRESS_B: '#2AD0A680',
  INPROGRESS_F: '#2AD0A6',
  COMPLETE_B: '#3366FF80',
  COMPLETE_F: '#3366FF',
  INACTIVE_B: '#BCB2B080',
  INACTIVE_F: '#BCB2B0',
  CANCEL_B: '#FF174480',
  CANCEL_F: '#FF1744',
}

const DateBar = ({ data, displayWidth, height }) => {
  const { offset, length, status, progressLength } = data
  const showFull = progressLength >= length

  let bColor = ''
  let fColor = ''

  switch (status) {
    case 'inprogress':
    case 'IP':
      bColor = COLOR.INPROGRESS_B
      fColor = COLOR.INPROGRESS_F
      break
    case 'complete':
    case 'COM':
    case 'EC':
      bColor = COLOR.COMPLETE_B
      fColor = COLOR.COMPLETE_F
      break
    case 'cancel':
    case 'CAN':
      bColor = COLOR.CANCEL_B
      fColor = COLOR.CANCEL_F
      break
    default:
      bColor = COLOR.INACTIVE_B
      fColor = COLOR.INACTIVE_F
      break
  }

  return (
    <Box sx={{ height, position: 'relative' }}>
      <Box
        sx={{
          left: `${displayWidth * offset}px`,
          width: `${displayWidth * length}px`,
          backgroundColor: bColor,
          ...barStyle,
        }}
      />

      {progressLength && progressLength > 0 ? (
        <Box
          sx={{
            left: `${displayWidth * offset}px`,
            width: `${showFull ? displayWidth * length : displayWidth * progressLength + 2.5}px`,
            ...barStyle,
            ...(showFull ? {} : { borderRadius: 0 }),
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              width: `${displayWidth * length}px`,
              backgroundColor: fColor,
              ...barStyle,
              top: 0,
              transform: 'unset',
            }}
          />
        </Box>
      ) : (
        <></>
      )}
    </Box>
  )
}

export default DateBar
